import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () => import('./shared/components/signin-callback/signin-callback.component').then(m => m.SigninCallbackComponent)
  },
  {
    path: '',
    canActivate: [autoLoginPartialRoutesGuard],
    canActivateChild: [autoLoginPartialRoutesGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./routes/company-master.routes').then(
            (mod) => mod.routes
          ),
        canActivate: [roleGuard],
        canActivateChild: [roleGuard]
      },
      {
        path: 'unauthorized-access',
        loadComponent: () =>
          import('./shared/components/unauthorized-access-page/unauthorized-access-page.component').then(
            (m) => m.UnauthorizedAccessPageComponent
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import(
            './shared/components/page-not-found/page-not-found.component'
          ).then((m) => m.PageNotFoundComponent),
      },
    ],
  },
];
